<template>
  <div>
    <!-- show loading indicator -->
    <loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">
      <!-- page-heading -->
      <page-heading
        :show="true"
        :pageTitle="equipmentCatalog.name"
      ></page-heading>

      <div class="columns">
        <div class="col-main">
          <!-- FILTER BAR -->
          <div class="filterBar is-clearfix">
            <div class="is-pulled-left">
              <div class="control is-grouped">
                <!-- SUCHE -->
                <div class="control has-icon search">
                  <input
                    class="input"
                    type="text"
                    v-model.trim="filterSearch"
                    placeholder="Suchbegriff"
                  />
                  <i class="fa fa-search" aria-hidden="true"></i>
                </div>

                <!-- CATEGORY FILTER -->
                <form-input
                  inputType="select"
                  label="EC-SELECT_BOX"
                  :showLabel="false"
                  :showLabelInOptions="false"
                  :selectOptions="equipmentSections"
                  v-model="filterSection"
                ></form-input>
              </div>
            </div>
          </div>

          <div class="box">
            <template v-if="filterSearch == '' && filterSection == null">
              <!-- COVER SECTION -->
              <div class="catalogSection">
                <div class="catalogSectionTitle">Cover</div>

                <div class="catalog">
                  <div class="pageWrapper cover">
                    <div class="page">
                      <vue-dropzone
                        ref="vueDropzone"
                        id="vueDropzone"
                        url="fileProcessing/upload?preset=equipmentCatalog"
                        :thumbnailWidth="145"
                        :thumbnailHeight="67"
                        :maxFiles="1"
                        acceptedFiles=".jpg,.pdf"
                        :dictDefaultMessage="
                          `<i class='fa fa-cloud-upload'></i> Upload Cover`
                        "
                        v-on:vdropzone-removed-file="dzRemove"
                        v-on:vdropzone-mounted="dzInit"
                        v-on:vdropzone-success="dzSuccess"
                        dzClass="dzSingle"
                      >
                      </vue-dropzone>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <!-- LOOP THROUGH OTHER SECTIONS -->
            <template
              v-for="(section, sectionIndex) in equipmentSections"
              v-if="filterSection == null || section.id == filterSection.id"
            >
              <!-- TABLE OF CONTENTS SECTION -->
              <div
                class="catalogSection tocSection"
                v-if="sectionIndex == 1 && filterSection == null"
              >
                <div class="catalogSectionTitle">Inhaltsverzeichnis</div>

                <div class="catalog">
                  <div class="pageWrapper" v-for="(page, index) in tocPages">
                    <div class="page">
                      <div class="pagePreviewContainer">
                        <div
                          class="preview lazy-img-fadein"
                          v-lazy:background-image="getImageAsset(page)"
                        ></div>
                      </div>
                      <div class="pageTitle">{{ page.title }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="catalogSection firstPageBlank">

                <div class="catalogSectionTitle">{{ section.name }}</div>

                <draggable
                  v-model="equipmentCatalog._pages"
                  :options="{
                    group: section.id,
                    animation: 200,
                    handle: '.dragHandler',
                    draggable: '.list-complete-item',
                    filter: '#blankPage'
                  }"
                  class="catalog"
                  @end="onDragComplete">

                    <div
                      v-for="(page, index) in filteredList"
                      :class="[{ inProgress: page.inProgress == true }, 'pageWrapper list-complete-item', page.status != null ? page.status.name : '']"
                      @click="goToPage(page)"
                      v-if="page.section && page.section.id == section.id"
                    >
                      <template v-if="page.inProgress == true">
                        <div class="page">
                          <loading-indicator-small></loading-indicator-small>
                        </div>
                      </template>

                      <template v-else>

                        <div class="page" @contextmenu.prevent="pageContextMenu($event, page, index)">

                          <div class="dragHandler" title="verschieben">
                            <span class="icon is-small">
                              <i class="icon-ak-move"></i>
                            </span>
                          </div>

                          <div class="pageIndex" v-if="sectionIndex != 0">
                            {{ page.sortorder - countIndexPages + 1 }}
                          </div>

                          <div class="pagePreviewContainer">
                            <div
                              class="preview lazy-img-fadein"
                              v-lazy:background-image="getImageAsset(page)"
                              :key="page"
                            ></div>
                          </div>

                          <div class="pageTitle">{{ page.title }}</div>
                        </div>

                      </template>

                    </div>

                </draggable>
              </div>
            </template>

            <!-- ARCHIVED LIST ITEMS -->
            <div
              class="catalogSection firstPageBlank"
              v-if="archivedList.length > 0"
            >
              <div class="catalogSectionTitle">Archivierte Seiten</div>
              <div class="catalog archived">
                <div
                  v-for="(page, index) in archivedList"
                  :class="[
                    { inProgress: page.inProgress == true },
                    'pageWrapper list-complete-item',
                    page.status != null ? page.status.name : ''
                  ]"
                  @click="goToPage(page)"
                  :key="page"
                >
                  <template v-if="page.inProgress == true">
                    <div class="page">
                      <loading-indicator-small></loading-indicator-small>
                    </div>
                  </template>

                  <template v-else>
                    <div
                      class="page"
                      @contextmenu.prevent="
                        pageContextMenu($event, page, index)
                      "
                    >
                      <!-- <div class="pageIndex" v-if="sectionIndex != 0">{{ page.sortorder - countIndexPages + 1 }}</div> -->
                      <div class="pagePreviewContainer">
                        <div
                          class="preview lazy-img-fadein"
                          v-lazy:background-image="getImageAsset(page)"
                          :key="page"
                        ></div>
                      </div>

                      <div class="pageTitle">{{ page.title }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-aside">
          <affix :offset="50">
            <custom-button
              type="blue"
              name="EC-BTN-PAGE_ADD"
              icon="icon-ak-hinzufuegen"
              @click.native="newEquipmentCatalogPage"
            ></custom-button>

            <div class="multiple">
              <export-to-pdf-button
                exportURL="equipmentCatalog/1/render"
                btnTitle="EC-BTN-EXPORT_TO_PDF_CATALOG"
                modalTitle="EC-MODAL_HEADER-EXPORT_TO_PDF_CATALOG"
              ></export-to-pdf-button>
              <export-button
                export="equipmentCatalog"
                btnTitle="EC-BTN-EXPORT_CATALOG"
                modalTitle="EC-MODAL_HEADER-EXPORT_CATALOG"
              ></export-button>
            </div>

            <router-link
              :to="{ name: 'equipmentCatalogChangeLog' }"
              v-if="userRole == 'Administrator'"
            >
              <custom-button
                name="EC-BTN-CHANGELOG"
                type="dark"
                icon="icon-ak-history"
              ></custom-button>
            </router-link>
          </affix>
        </div>


				<!-- CONTEXT MENU -->
				<context-menu class="context-menu" ref="ctxMenu" :key="currentPage">
					<li @click="pageEdit()">
						<span class="icon is-small"
							><i class="icon-ak-bearbeiten"></i></span
						>{{ $t("CE-CONTEXT_MENU-EDIT") }}
					</li>
					<li @click="pageAdd()">
						<span class="icon is-small"
							><i class="icon-ak-hinzufuegen"></i></span
						>{{ $t("CE-CONTEXT_MENU-COPY") }}
					</li>
					<li @click="pageClone()">
						<span class="icon is-small"
							><i class="icon-ak-duplizieren"></i></span
						>{{ $t("CE-CONTEXT_MENU-CLONE") }}
					</li>

					<template	v-if="currentPage == null || (currentPage != null && currentPage.archived == false)">
						<li @click="archivePage()"><span class="icon is-small"><i class="fa fa-archive"></i></span>{{ $t("CE-CONTEXT_MENU-ARCHIVE")}}</li>
					</template>
					<template	v-else-if="currentPage == null || (currentPage != null && currentPage.archived === true)">
						<li @click="restorePage()">
							<span class="icon is-small"><i class="icon-ak-reset"></i></span>
							{{ $t("CE-CONTEXT_MENU-RESTORE") }}
						</li>
					</template>

					<li @click="pageDelete()">
						<span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
						{{ $t("CE-CONTEXT_MENU-DELETE") }}
					</li>
				</context-menu>


      </div>
    </template>

		<!--
    <lang labelKey="EC-MSG-PAGE_SUCCESSFULLY_ARCHIVED" /><br>
		<lang labelKey="EC-MSG-PAGE_SUCCESSFULLY_RESTORED" />
		-->

  </div>
</template>

<script>
import contextMenu from "vue-context-menu";
import draggable from "vuedraggable";
import exportButton from "../utils/exportButton";
import exportToPdfButton from "../utils/exportToPdfButton";
import vueDropzone from "../utils/dropzoneWrapper";

export default {
  name: "equipmentCatalog",

  components: {
    contextMenu,
    draggable,
    exportButton,
    exportToPdfButton,
    vueDropzone
  },

  data() {
    return {
      isLoading: false,

      equipmentCatalog: null,
      equipmentCatalogArchivedPages: null,

      equipmentSections: null,

      filterSection: null,
      filterSearch: "",

      filterSortorder: {
        name: "aufsteigend",
        id: "1"
      },

      tocPages: [],
      countIndexPages: 0,

      sortorder: [
        {
          name: "aufsteigend",
          value: false
        },
        {
          name: "absteigend",
          value: true
        }
      ],
      reversePages: {
        name: "aufsteigend",
        value: false
      },
      currentPage: null,
      currentPageIndex: null
    };
  },

  computed: {

    filteredList() {
      return this.equipmentCatalog._pages.filter(page => {
        if (!page.archived && !page.deleted && typeof page.title != 'undefined') {
          return page.title.toLowerCase().indexOf(this.filterSearch.toLowerCase()) > -1;
        }
      });
    },

    archivedList() {
      // return this.equipmentCatalog.pages.filter((page) => page.archived == true);
      return this.equipmentCatalog._pagesArchived;
    },

    EquipmentCatalogPageStatus() {
      return this.$store.getters.getTermsByTaxonomy(
        "EQUIPMENT_CATALOG_PAGE_STATUS"
      );
    }
  },

  watch: {

    reversePages(newVal, oldVal) {
      this.equipmentCatalog._pages.reverse();
      this.equipmentSections.reverse();
    },

    filterSection(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.commit("setEquipmentCatalogFilter", {
          type: "filterSection",
          value: newVal
        });
      }
    },

    filterSearch(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.commit("setEquipmentCatalogFilter", {
          type: "filterSearch",
          value: newVal
        });
      }
    }
  },

  created() {

    this.filterSection = this.$store.getters.getEquipmentCatalogFilter(
      "filterSection"
    );

    this.filterSearch =
      this.$store.getters.getEquipmentCatalogFilter("filterSearch") == null
        ? ""
        : this.$store.getters.getEquipmentCatalogFilter("filterSearch");

    this.fetchData();
  },

  mounted() {

  },

  methods: {

    dzInit() {
      var self = this;

      if (this.equipmentCatalog.cover) {
        var filename =
          this.equipmentCatalog.cover.filename.split(".").pop() == "pdf"
            ? this.equipmentCatalog.cover.filename.substr(
                0,
                this.equipmentCatalog.cover.filename.lastIndexOf(".")
              ) + ".jpg"
            : this.equipmentCatalog.cover.filename;

        // set the url
        let url =
          this.$config.assets +
          this.equipmentCatalog.cover.path +
          "/thumb/" +
          filename;
        var mockFile = {
          id: "ecCover",
          name: filename,
          type: "image/*",
          size: 123
        };

        // add mockFile to our dropzone
        this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);
      }
    },

    dzSuccess(file) {
      this.$refs.vueDropzone.$children[0].removeAllFiles();

      var result = JSON.parse(file.xhr.response);

      this.equipmentCatalog.cover = {
        filename: result.fileName,
        path: result.dir,
        uploadFilename: file.name
      };

      // set the url
      var filename =
        this.equipmentCatalog.cover.filename.substr(
          0,
          this.equipmentCatalog.cover.filename.lastIndexOf(".")
        ) + ".jpg";
      let url =
        this.$config.assets +
        this.equipmentCatalog.cover.path +
        "/thumb/" +
        filename;
      var mockFile = {
        id: "ecCover",
        name: filename,
        type: "image/*",
        size: 123
      };

      // add mockFile to our dropzone
      this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

      this.saveCover({
        isSilent: false,
        msg: "EC-MSG-COVER_SUCCESSFULLY_UPLOADED"
      });
    },

    dzRemove(file, error, xhr) {
      if (typeof file === "undefined") {
        return;
      }

      this.equipmentCatalog.cover = null;

      // this.saveCover( { isSilent: true, msg: 'EC-MSG-COVER_SUCCESSFULLY_REMOVED' } );
    },

    removeCover() {
      this.equipmentCatalog.cover = null;
      // this.saveCover( { isSilent: false, msg: 'EC-MSG-COVER_SUCCESSFULLY_REMOVED' } );
    },

    onDragComplete(ev) {

      // reorder
      this.reorderPages();

      /*
      this.saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_MOVED"
      });
      */

      this._saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_MOVED"
      });

    },

    getImageAsset(page) {
      // if(page.section && page.section.id == 1) {
      // 	console.log(page.section.name);
      // 	console.log(page.thumbnail);
      // }

      return page.thumbnail != null
        ? this.$config.assets +
            page.thumbnail.path +
            "/" +
            page.thumbnail.filename
        : "";
    },

    goToPage(page) {
      if (page.inProgress == true) {
        return false;
      }

      this.$router.push({
        name: "equipmentCatalogPage",
        params: { equipmentCatalogPageID: page.id }
      });
    },

    pageEdit() {
      this.goToPage(this.currentPage);
    },

    /* Context Menu Detail View */
    pageContextMenu(e, page, index) {

      this.currentPage = page;
      this.currentPageIndex = index;

			setTimeout(() => {
				// open context menu
				this.$refs.ctxMenu.open(e);
			}, 100);

    },


    archivePage() {

      this.currentPage.archived = true;
      this.equipmentCatalog._pagesArchived.push(this.currentPage);
      this.equipmentCatalog._pages.splice(this.currentPageIndex, 1);
      this.reorderPages();

      this._saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_ARCHIVED"
      });

    },

    restorePage() {

      this.currentPage.archived = false;
      this.equipmentCatalog._pages.push(this.currentPage);
      this.equipmentCatalog._pagesArchived.splice(this.currentPageIndex, 1);
      this.reorderPages();


      this._saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_RESTORED"
      });


    },
    /*
    pageArchive() {
      this.currentPage.archived = true;
      this._saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_ARCHIVED"
      });
    },

    pageRestore() {
      this.currentPage.archived = false;
      this._saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_RESTORED"
      });
    },
    */

    reorderPages() {

      this.equipmentCatalog._pages.forEach((page, index) => page.sortorder = index);
      this.$forceUpdate();
      // this.equipmentCatalog._pages.forEach((page, index) => page.sortorder = index);
      // console.log(this.equipmentCatalog._pages);
    },


    pageDelete() {

      this.saveCatalog(
        { isSilent: false, msg: "EC-MSG-PAGE_SUCCESSFULLY_DELETED" },
        this.currentPage.id
      );

    },

    pageAdd() {
      let cloned = JSON.parse(
        JSON.stringify(this.equipmentCatalog._pages[this.currentPageIndex])
      );

      cloned.id = null;
      cloned.thumbnail = null;
      cloned.title = "";
      cloned.status = null;
      cloned.inProgress = true;

      // add the new page
      this.equipmentCatalog._pages.splice(this.currentPageIndex + 1, 0, cloned);

      // check if the page to be inserted is an "index" page (first section)
      // if so: increment the countIndexPages counter
      if (cloned.section.id == this.equipmentSections[0].id) {
        this.countIndexPages += 1;
      }

      // reorder
      this.equipmentCatalog._pages.forEach((page, index)  => page.sortorder = index );

      this.saveCatalog({
        isSilent: false,
        msg: "EC-MSG-PAGE_SUCCESSFULLY_ADDED"
      });
    },

    pageClone() {
      var self = this;
      var pageIndex = Math.random()
        .toString(36)
        .substr(2, 9);

      let cloned = JSON.parse(
        JSON.stringify(this.equipmentCatalog._pages[this.currentPageIndex])
      );
      cloned.id = null;
      cloned.thumbnail = null;
      cloned.title = "";
      cloned.status = null;
      cloned.inProgress = true;

      // add the new page
      this.equipmentCatalog._pages.splice(this.currentPageIndex + 1, 0, cloned);

      this.axios
        .get(
          this.$config.api +
            "equipmentCatalogPage/" +
            this.equipmentCatalog._pages[this.currentPageIndex].id +
            "/duplicate"
        )
        .then(function(res) {
          res.data.inProgress = false;

          // assign new page data
          self.$set(
            self.equipmentCatalog._pages,
            [self.currentPageIndex + 1],
            res.data
          );
          // self.equipmentCatalog.pages[self.currentPageIndex+1] = res.data;

          // assign category
          self.equipmentCatalog._pages[
            self.currentPageIndex + 1
          ].section = self.equipmentSections.find(function(element) {
            return element.id ==
              self.equipmentCatalog._pages[self.currentPageIndex + 1].section
              ? element
              : null;
          });

          // check if the page to be inserted is an "index" page (first section)
          // if so: increment the countIndexPages counter
          if (
            self.equipmentCatalog._pages[self.currentPageIndex].section.id ==
            self.equipmentSections[0].id
          ) {
            self.countIndexPages += 1;
          }

          // reorder
          self.equipmentCatalog._pages.forEach((page, index) => {
            page.sortorder = index;
            page.inProgress == false;
          });

          // success msg
          self.$notify.success({
            content: self.$t("EC-MSG-PAGE_SUCCESSFULLY_DUPLICATED")
          });
        })
        .catch(function(msg) {
          // success msg
          self.$notify.danger({ content: msg });
        });
    },

    newEquipmentCatalogPage() {
      this.$router.push({ name: "equipmentCatalogPageNew" });
    },

    saveCover(options = null) {
      var self = this;

      if (options == null) {
        options = {
          isSilent: false,
          msg: ""
        };
      }

      this.entityCreateOrUpdate(
        "equipmentCatalog",
        self.equipmentCatalog,
        options
      ).then(function(response) {});
    },

    saveCatalog(options = null, deletePageId = null) {
      // var self = this;

      if (options == null) {
        options = {
          isSilent: false,
          msg: ""
        };
      }

      // DELETE ENTRY
      if (deletePageId != null) {

        this.entityDelete(
          "equipmentCatalogPage",
          deletePageId,
          "EC-CONFIRM-DELETE_PAGE"
        ).then((response) => {
          this.equipmentCatalog._pages[this.currentPageIndex].inProgress = true;

          // check if the page to be inserted is an "index" page (first section)
          // if so: decrement the countIndexPages counter
          if (
            this.equipmentCatalog._pages[this.currentPageIndex].section.id ==
            this.equipmentSections[0].id
          ) {
            this.countIndexPages -= 1;
          }


          // remove page from array
          let pageIndexToDelete = this.equipmentCatalog._pages.findIndex((p) => p.id == deletePageId);

          if(pageIndexToDelete !== -1) {
            this.equipmentCatalog._pages.splice(pageIndexToDelete, 1);
            this.$forceUpdate();
            // console.log("PAGE DELETED: ", pageIndexToDelete, deletePageId)
          }


/*
          // remove page from array
          if (this.currentPageIndex > -1) {
            this.equipmentCatalog.pages.splice(this.currentPageIndex, 1);
            this.$forceUpdate();
            // let x = this.equipmentCatalog.pages.splice(this.currentPageIndex, 1);
            // this.$set(this.equipmentCatalog, 'pages', x)
          }
*/


          // reorder
          this.equipmentCatalog._pages.forEach((page, index) => page.sortorder = index);

          // as we updated the sortorder, we've to save it back to DB
          this._saveCatalog({ isSilent: true });
        });

      // POST ENTRY
      } else {

        var pages = [
          ...this.equipmentCatalog._pages,
          ...this.equipmentCatalog._pagesArchived
        ]

        // this.entityCreateOrUpdate("equipmentCatalogPage", this.equipmentCatalog._pages, options)
        this.entityCreateOrUpdate("equipmentCatalogPage", pages, options)
          .then(res => {
            // assign the id of the newly inserted page
            this.equipmentCatalog._pages[this.currentPageIndex + 1].id = res.equipmentCatalogPage[this.currentPageIndex + 1].id;
            this.equipmentCatalog._pages[this.currentPageIndex + 1].inProgress = false;
          });
      }

    },

    _saveCatalog(options = null) {

      if (options == null) {
        options = {
          isSilent: false,
          msg: ""
        };
      }


      var pages = [
        ...this.equipmentCatalog._pages,
        ...this.equipmentCatalog._pagesArchived
      ]

      //console.log("PAGES TO SAVE: ", pages);
      this.entityCreateOrUpdate("equipmentCatalogPage", pages, options);
      // this.entityCreateOrUpdate("equipmentCatalogPage", this.equipmentCatalog._pages, options);

    },

    fetchData() {

      var self = this;
      this.isLoading = true;

      // fetch sections
      function getSections() {
        return self.axios.get(
          self.$config.api + "equipmentCatalogSection?orderBy=sortorder"
        );
      }

      // fetch tableOfContentsPages
      function getTableOfContentsPages() {
        return self.axios.get(
          self.$config.api + "equipmentCatalog/1/tableOfContentsPages"
        );
      }

      // fetch catalog
      function getEquipmentCatalogPages() {
        return self.axios.get(
          self.$config.api +
            "equipmentCatalog/" +
            self.equipmentCatalogId +
            "?include=equipmentCatalog.cover,equipmentCatalog.pages,equipmentCatalogPage.section,equipmentCatalogPage.categories,equipmentCatalogPageCategory.category,equipmentCategory.products,equipmentCatalogPage.thumbnail,equipmentCatalogPage.status&orderBy=equipmentCatalogPage.sortorder"
        );
      }

      this.axios
        .all([
          getSections(),
          getTableOfContentsPages(),
          getEquipmentCatalogPages()
        ])
        .then(

          self.axios.spread(function(sections, tocPages, catalogPages) {

            self.tocPages = tocPages.data;

            // self.equipmentCatalogArchivedPages = catalogPages.data.pages.filter((p) => p.archived);


            self.equipmentCatalog = {
              ... catalogPages.data,
              _pages: catalogPages.data.pages.filter((p) => p.deleted == false && p.archived == false),
              _pagesArchived: catalogPages.data.pages.filter((p) => p.archived)
            }

            // self.equipmentCatalog = catalogPages.data;

            self.equipmentSections = sections.data.equipmentCatalogSection;
            self.isLoading = false;

            // get the id of the very first section ("introseiten")
            var sectionIndexId = self.equipmentSections[0].id;

            // ... and loop through the pages array and
            // count the pages with the section.id == sectionIndexId
            self.countIndexPages = 0;
            self.equipmentCatalog._pages.forEach((page, index) => {

              if (page.section && page.section.id == sectionIndexId) {
                self.countIndexPages++;
              }
            });

          })
        );
    }
  }
};
</script>

<style>
.catalog .pageWrapper.cover .page .vue-dropzone .dz-image img {
  height: auto !important;
  width: auto !important;
  object-fit: contain !important;
}
.catalog .pageWrapper.cover .dz-preview {
  height: 200px !important;
}
</style>

<style lang="scss" scoped>
@import "~../../assets/css/variables.scss";

.catalog .pageWrapper.DEFAULT > .page > .pageTitle {
  border-top-color: $statusEquipmentCatalogPageDefault !important;
}
.catalog .pageWrapper.EDIT > .page > .pageTitle {
  border-top-color: $statusEquipmentCatalogPageEdit !important;
}
.catalog .pageWrapper.READY > .page > .pageTitle {
  border-top-color: $statusEquipmentCatalogPageReady !important;
}
</style>

<style scoped>
.sortable-ghost {
  background: #def2ed !important;
}

.list-complete-item {
}
.list-complete-enter,
.list-complete-leave-active {
  opacity: 0 !important;
}

.filterBar {
  margin: 0 0 10px 0;
}

.catalogSection {
  margin: 0 auto 35px auto;
}
.catalogSection > .catalogSectionTitle {
  text-align: center;
  font-size: 22px;
  padding: 20px 0;
  /*
		border-bottom: 1px solid #F5F7F9;
		*/
  border-bottom: 2px solid #ddd;
  margin: 0 -25px 35px -25px;
}

.catalog {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.catalog.archived {
  opacity: 0.4;
}

.catalog .pageWrapper {
  position: relative;
  margin: 0 0.8% 15px;
  margin-bottom: 15px;
  border-radius: 5px;
  /*
		border: 1px solid #ddd;
		*/
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}
.catalog .pageWrapper:before {
  content: "";
  display: block;
  padding-top: 125%;
}
.catalog .pageWrapper.cover:before {
  padding-top: 100%;
}

.catalogSection:not(.firstPageBlank) .pageWrapper {
  margin: 0 0.4% 15px !important;
}

.catalog .pageWrapper .dragHandler {
  position: absolute;
  z-index: 2;
  top: 0;
  margin: 0;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center !important;
  align-items: center;
  text-align: center;
  cursor: move;
  /*background: #f0f0f0;*/
  color: #ddd;
  border-radius: 4px;
  transition: all 0.3s ease;
}
.catalog .pageWrapper .dragHandler:hover {
  background: #fff;
  color: #000;
}

.catalog .pageWrapper > .page {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  margin: 3%;
}

/*********/
.catalog .pageWrapper > .page.green {
  background-color: red !important;
}
/*******/

.catalog .pageWrapper > .page > .pageIndex {
  position: absolute;
  bottom: 3.5vw;
  left: 0;
  padding: 0 10px;
  font-size: 0.75vw;
  color: #aaa;
}
.catalog .pageWrapper > .page > .pageTitle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 0.65vw;
  text-align: center;
  height: 3.3vw;
  line-height: 0.85vw;
  display: flex;
  align-items: center;
  border-top: 3px solid #e5e7e9;
}
.catalog .pageWrapper > .page > .pagePreviewContainer {
  position: absolute;
  top: 0.5vw;
  bottom: 3.3vw;
}

.catalog .pageWrapper.inProgress {
  background-color: #f5f7f9;
}
.catalog .pageWrapper > .page .v-spinner {
  height: 70%;
}

.catalog .pageWrapper > .page > .pagePreviewContainer > .preview {
  width: 80%;
  height: 0;
  padding-bottom: 111%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  -webkit-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
}
.catalog
  .pageWrapper
  > .page
  > .pagePreviewContainer
  > .preview[lazy="loading"] {
  background-size: 40% !important;
}

/* cover page */
.catalog .pageWrapper.cover .page {
  margin: 3% !important;
}
.catalog .pageWrapper.cover .page .vue-dropzone {
  height: 100%;
}

/* TOC Pages */
.tocSection .pageWrapper {
  margin-left: 0.8%;
  margin-right: 0.8%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.tocSection .pageWrapper .dragHandler {
  left: 0;
}
.tocSection .pageWrapper > .page {
}
.tocSection .pageWrapper > .page > .pagePreviewContainer {
  left: 1.2vw;
  right: 1.2vw;
}
.tocSection .pageWrapper > .page > .pagePreviewContainer .preview {
  margin: 0 auto;
}
.tocSection .pageWrapper > .page > .pageTitle {
  justify-content: center;
  text-align: center;
}

/* EVEN pages */
.firstPageBlank .pageWrapper:nth-child(even) {
  margin-left: 0.8%;
  margin-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.firstPageBlank .pageWrapper:nth-child(even) .dragHandler {
  left: 0;
}
.firstPageBlank .pageWrapper:nth-child(even) > .page {
  margin-right: 5%;
}
.firstPageBlank .pageWrapper:nth-child(even) > .page > .pagePreviewContainer {
  left: 2.5vw;
  right: 0;
}
.firstPageBlank
  .pageWrapper:nth-child(even)
  > .page
  > .pagePreviewContainer
  .preview {
  margin: 0 0 0 auto;
}
.firstPageBlank .pageWrapper:nth-child(even) > .page > .pageTitle {
  justify-content: flex-end;
  text-align: right;
}

/* ODD pages */
.firstPageBlank .pageWrapper:nth-child(odd) {
  margin-left: 0;
  margin-right: 0.8%;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 1px solid #bbb;
}
.firstPageBlank .pageWrapper:nth-child(odd) .dragHandler {
  right: 0;
}
.firstPageBlank .pageWrapper:nth-child(odd) > .page {
  margin-left: 5%;
}
.firstPageBlank .pageWrapper:nth-child(odd) > .page > .pageIndex {
  right: 0;
  left: auto;
}
.firstPageBlank .pageWrapper:nth-child(odd) > .page > .pagePreviewContainer {
  left: 0;
  right: 2.5vw;
}
.firstPageBlank
  .pageWrapper:nth-child(odd)
  > .page
  > .pagePreviewContainer
  .preview {
  margin: 0 auto 0 0;
}
.firstPageBlank .pageWrapper:nth-child(odd) > .page > .pageTitle {
  justify-content: flex-start !important;
  text-align: left;
}

.firstPageBlank .pageWrapper:first-child {
  margin-left: 16% !important;
}

/*
	.catalog .pageWrapper.inProgress {
		opacity: .45;
    }
	*/
.catalog .pageWrapper:hover {
  background-color: #f5f7f9;
}

/* phantom container for last row alignment */
.catalog .pageWrapper.phantom {
  visibility: hidden;
  height: 20px;
  width: 15%;
  flex-grow: 1;
  display: none;
}

/* 6 per row */
@media all and (min-width: 1280px) {
  .firstPageBlank .pageWrapper:first-child {
    margin-left: 16% !important;
  }
  .catalog .pageWrapper {
    width: 15%;
  }
  .catalog .pageWrapper:nth-of-type(6n) {
    margin-right: 0;
  }
  .catalog .pageWrapper:nth-of-type(6n + 1) {
    margin-left: 0;
  }
}

/* 4 per row */
@media all and (min-width: 780px) and (max-width: 1279px) {
  .firstPageBlank .pageWrapper:first-child {
    margin-left: 25% !important;
  }
  .catalog .pageWrapper {
    width: 24%;
  }
  .catalog .pageWrapper:nth-of-type(4n) {
    margin-right: 0;
  }
  .catalog .pageWrapper:nth-of-type(4n + 1) {
    margin-left: 0;
  }
}

/* 2 per row */
@media all and (min-width: 312px) and (max-width: 779px) {
  .firstPageBlank .pageWrapper:first-child {
    margin-left: 46% !important;
  }
  .catalog .pageWrapper {
    width: 45%;
  }
  .catalog .pageWrapper:nth-of-type(2n) {
    margin-right: 0;
  }
  .catalog .pageWrapper:nth-of-type(2n + 1) {
    margin-left: 0;
  }
}

/* CONTEXT MENU STYLE */
.ctx-menu-container {
  position: fixed;
  padding: 0 !important;
  border: none !important;
  outline: none !important;
  height: 0;
  width: 0;
}
.ctx-menu {
  padding: 5px 4px;
  width: auto;
  background: #fff !important;
  border: 1px solid #c5c5c5 !important;
  border-radius: 0 !important;
  box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.3) !important;
}
.ctx-menu li {
  padding: 5px 8px !important;
  cursor: pointer;
  white-space: nowrap;
}
.ctx-menu li:hover {
  background: #eee;
}
.ctx-menu li .icon {
  margin-right: 8px;
}
</style>
